import useIsMobile from "@/hooks/useIsMobile";
import NotificationDesktop from "./desktop";
import NotificationMobile from "./mobile";
import useComponent from "./useComponent";

const NotificationPage = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useComponent();

  if (isMobile) {
    return <NotificationMobile viewModel={viewModel} />;
  }

  return <NotificationDesktop viewModel={viewModel} />;
};

export default NotificationPage;
